<template>
  <div class="offer-customizer">
    <ui-save-bar id="my-save-bar">
      <button
        variant="primary"
        id="save-button"
        @click="onSaveBarSaveClicked"
      ></button>
      <button id="discard-button" @click="onSaveBarDiscardClicked"></button>
    </ui-save-bar>

    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-grid-template-columns-md:minmax(0, 1fr) minmax(0, 2fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
      v-if="config.badgeConfig"
    >
      <div style="display:inherit;width:auto;border-inline-start:none">
        <div>
          <div style="color:var(--p-color-text-info-on-bg-fill);width:auto">
            <div class="Polaris-LegacyCard">
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Position
                    </h2>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section">
                <div class="Polaris-FormLayout Polaris-FormLayout--condensed">
                  <div class="Polaris-FormLayout__Item">
                    <div class="Polaris-Select">
                      <select
                        class="Polaris-Select__Input"
                        v-model="config.badgeConfig.position"
                        aria-invalid="false"
                      >
                        <option value="left">Left</option>
                        <option value="right">Right</option>
                      </select>
                      <div class="Polaris-Select__Content" aria-hidden="true">
                        <span class="Polaris-Select__SelectedOption">{{
                          config.badgeConfig.position
                        }}</span>
                        <span class="Polaris-Select__Icon">
                          <span class="Polaris-Icon">
                            <svg
                              viewBox="0 0 20 20"
                              class="Polaris-Icon__Svg"
                              focusable="false"
                              aria-hidden="true"
                            >
                              <path
                                d="M10 14a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 1.5 0v3.5a.75.75 0 0 1-.75.75Z"
                              ></path>
                              <path
                                d="M9 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
                              ></path>
                            </svg>
                          </span>
                        </span>
                      </div>
                      <div class="Polaris-Select__Backdrop"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="Polaris-LegacyCard mt-4">
              <div class="Polaris-LegacyCard__Section">
                <div
                  class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
                >
                  <div
                    class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
                  >
                    <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                      Colors
                    </h2>
                  </div>
                </div>
              </div>
              <div class="Polaris-LegacyCard__Section">
                <div class="Polaris-FormLayout Polaris-FormLayout--condensed">
                  <div class="Polaris-FormLayout__Item">
                    <div class="Polaris-Labelled__LabelWrapper">
                      <div class="Polaris-Label">
                        <label
                          class="Polaris-Label__Text"
                          for="cardBackgroundColor"
                          >Card Background Color</label
                        >
                      </div>
                    </div>
                    <div class="Polaris-Connected">
                      <div
                        class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                      >
                        <div class="Polaris-TextField">
                          <Verte
                            picker="square"
                            model="hex"
                            v-model="config.badgeConfig.cardBackgroundColor"
                            class="colorPicker"
                          ></Verte>
                          <input
                            class="Polaris-TextField__Input hasColor"
                            v-model="config.badgeConfig.cardBackgroundColor"
                          />
                          <div class="Polaris-TextField__Backdrop"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Polaris-FormLayout__Item">
                    <div class="Polaris-Labelled__LabelWrapper">
                      <div class="Polaris-Label">
                        <label class="Polaris-Label__Text" for="starColor"
                          >Star Color</label
                        >
                      </div>
                    </div>
                    <div class="Polaris-Connected">
                      <div
                        class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                      >
                        <div class="Polaris-TextField">
                          <Verte
                            picker="square"
                            model="hex"
                            v-model="config.badgeConfig.starColor"
                            class="colorPicker"
                          ></Verte>
                          <input
                            class="Polaris-TextField__Input hasColor"
                            v-model="config.badgeConfig.starColor"
                          />
                          <div class="Polaris-TextField__Backdrop"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Polaris-FormLayout__Item">
                    <div class="Polaris-Labelled__LabelWrapper">
                      <div class="Polaris-Label">
                        <label class="Polaris-Label__Text" for="textColor"
                          >Text Color</label
                        >
                      </div>
                    </div>
                    <div class="Polaris-Connected">
                      <div
                        class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                      >
                        <div class="Polaris-TextField">
                          <Verte
                            picker="square"
                            model="hex"
                            v-model="config.badgeConfig.textColor"
                            class="colorPicker"
                          ></Verte>
                          <input
                            class="Polaris-TextField__Input hasColor"
                            v-model="config.badgeConfig.textColor"
                          />
                          <div class="Polaris-TextField__Backdrop"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Polaris-FormLayout__Item ">
                    <div class="">
                      <div class="Polaris-Labelled__LabelWrapper">
                        <div class="Polaris-Label">
                          <label
                            id=":R1mq6:Label"
                            for=":R1mq6:"
                            class="Polaris-Label__Text"
                            >Reviews Count Label</label
                          >
                        </div>
                      </div>
                      <div class="Polaris-Connected">
                        <div
                          class="Polaris-Connected__Item Polaris-Connected__Item--primary"
                        >
                          <div class="Polaris-TextField ">
                            <input
                              id=":R1mq6:"
                              v-model="config.badgeConfig.reviewCountLabel"
                              autocomplete="off"
                              class="Polaris-TextField__Input "
                              type="text"
                              aria-labelledby=":R1mq6:Label"
                              aria-invalid="false"
                              data-1p-ignore="true"
                              data-lpignore="true"
                              data-form-type="other"
                              value=""
                            />

                            <div class="Polaris-TextField__Backdrop"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div class="Polaris-LegacyCard">
          <div class="Polaris-LegacyCard__Section">
            <div
              class="Polaris-LegacyStack Polaris-LegacyStack--alignmentCenter"
            >
              <div
                class="Polaris-LegacyStack__Item Polaris-LegacyStack__Item--fill"
              >
                <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                  Preview
                </h2>
                <FloatingWidgetPreview
                  :config="config"
                  class="mt-4"
                ></FloatingWidgetPreview>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Verte from "verte";
import "verte/dist/verte.css";
import { cloneDeep } from "lodash-es";
import FloatingWidgetPreview from "./FloatingWidgetPreview.vue";

export default {
  components: {
    Verte,
    FloatingWidgetPreview
  },
  data() {
    return {
      config: {},
      originalConfig: {},
      hasUnsavedChanges: false,
      saveBar: null
    };
  },
  watch: {
    config: {
      deep: true,
      handler() {
        this.checkForChanges();
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.saveBar = document.getElementById("my-save-bar");
  },
  methods: {
    init() {
      this.$store.dispatch("getWidgetConfig").then(response => {
        this.config = cloneDeep(response.config);
        this.originalConfig = cloneDeep(response.config);
      });
    },
    updateSettings() {
      const payload = this.config;
      delete payload.id;

      this.$store
        .dispatch("updateWidgetConfig", { requestParams: payload })
        .then(response => {
          this.$store.dispatch("showNotification", {
            text: "Settings updated"
          });
          this.hasUnsavedChanges = false;
          this.config = cloneDeep(response.config);
          this.originalConfig = cloneDeep(response.config);
        });
    },
    checkForChanges() {
      if (JSON.stringify(this.config) !== JSON.stringify(this.originalConfig)) {
        this.saveBar.show();
        this.hasUnsavedChanges = true;
      } else {
        this.hasUnsavedChanges = false;
        this.saveBar.hide();
      }
    },
    onSaveBarSaveClicked() {
      this.updateSettings();
      this.saveBar.hide();
    },
    onSaveBarDiscardClicked() {
      this.config = cloneDeep(this.originalConfig);
      this.saveBar.hide();
    }
  }
};
</script>

<style lang="scss">
.colorPicker {
  position: absolute !important;
  top: 4px;
  left: 8px;
  z-index: 100;
}

.verte.colorPicker .verte__menu-origin--active {
  z-index: 10000 !important;
}

.verte.colorPicker:has(.verte__menu-origin--active) {
  z-index: 10000 !important;
}

.Polaris-Connected__Item--primary:focus-within .verte.colorPicker,
.Polaris-Connected__Item--primary:hover .verte.colorPicker {
  z-index: 10000 !important;
}

.Polaris-TextField__Input.hasColor {
  padding-left: 42px;
}

.offer-customizer .Polaris-LegacyCard {
  overflow: visible;
}

.offer-customizer .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}

.offer-customizer .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}
</style>
